var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-details-section-header"},[_c('div',{staticClass:"text-h4 mt-8"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticClass:"my-2"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }